import { APP_TRANSACTION, TRANSACTION_HISTORY } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IAirTimeRegistrationRepository } from "features/airTimeRegistration/domain/repositories/IAirTimeRegistrationRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { AirTimeRegistrationDetailModel } from "./model/AirTimeRegistrationDetailModel";
import { AirTimeRegistrationRequestModel } from "./model/AirTimeRegistrationRequestModel";
import { AirTimeRegistrationResponseModel } from "./model/AirTimeRegistrationResponseModel";

@injectable()
export class AirTimeRegistrationImpl implements IAirTimeRegistrationRepository {
  async getList(
    params: AirTimeRegistrationRequestModel,
    usePrivateList = false
  ): Promise<ListBaseApiResponseModel<AirTimeRegistrationResponseModel>> {
    const url = StringFormat.buildListUrl<AirTimeRegistrationRequestModel>(
      usePrivateList
        ? TRANSACTION_HISTORY.PRIVATE_LIST
        : TRANSACTION_HISTORY.AIRTIMELIST,
      params
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getDetail(
    params: AirTimeRegistrationRequestModel,
    usePrivateDetail = false
  ): Promise<BaseApiResponseModel<AirTimeRegistrationDetailModel>> {
    const detailPath = usePrivateDetail
      ? TRANSACTION_HISTORY.PRIVATE_TRANS_DETAIL
      : APP_TRANSACTION.DETAIL;
    return await client?.get(detailPath, params);
  }

  async exportReport(
    params: AirTimeRegistrationRequestModel,
    usePrivateList = false
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      usePrivateList
        ? TRANSACTION_HISTORY.PRIVATE_LIST
        : TRANSACTION_HISTORY.AIRTIMELIST,
      params
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
